export default {"src":"/_next/static/media/trad-ira.7dd42de8.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};